<template>
    <page :sticky-header="true">
        <template slot="header">
            <icon-text-button :icon="authorized ? 'check_mark' : 'account_circle'"
                              :label="authorized ? 'Authorized' : 'Authorize'"
                              :disabled="authorized"
                              primary
                              @click="authorize"/>
        </template>
        <api-resource :resource="resource"/>
    </page>
</template>

<script>
  import { ROUTE_OAUTH } from '../../router';
  import ApiResource     from '../ApiResource';
  import IconTextButton  from '../Forms/IconTextButton';
  import SelectField     from '../Forms/SelectField';
  import Page            from '../Layout/Page';

  export default {
    name: 'ResourceView',

    components: {
      SelectField,
      IconTextButton,
      ApiResource,
      Page,
    },

    props: {
      slug: {
        type:     String,
        required: true,
      },
    },

    data () {
      return {};
    },

    computed: {
      resource () {
        return this.$api.resources.find(resource => resource.slug === this.slug);
      },

      authorized () {
        return this.$auth.isAuthorized();
      },
    },

    methods: {
      slugify ( string ) {
        return string
          .replace(/([a-z0-9])([A-Z])/g, '$1-$2')
          .replace(/([A-Z])([A-Z])(?=[a-z])/g, '$1-$2')
          .toLowerCase();
      },
      authorize () {
        this.$router.push({ name: ROUTE_OAUTH, query: { previous: this.$route.fullPath } });
      },
    },
  };
</script>

<style scoped>

</style>
